import { type Dispatch, useMemo } from 'react';

import {
  type Actions,
  eActionTypes,
  type IEstimationWizardStep,
  type ReducerActiveStep,
} from '@/context/estimationWizardContext/model.ts';

export const useActions = (dispatch: Dispatch<Actions>) =>
  useMemo(
    () => ({
      setActiveStep: (payload: ReducerActiveStep) => {
        dispatch({ type: eActionTypes.SET_ACTIVE_STEP, payload });
      },
      setWizardVisible: (payload: boolean) => {
        dispatch({ type: eActionTypes.SET_IS_WIZARD_VISIBLE, payload });
      },
      cancelWizard: () => {
        dispatch({ type: eActionTypes.CANCEL_WIZARD });
      },
      setWizardSteps: (payload: IEstimationWizardStep[]) => {
        dispatch({ type: eActionTypes.SET_WIZARD_STEPS, payload });
      },
    }),
    [dispatch],
  );
